import useClickListener from "../../utils/hooks/useClickListener"
import { containsValidTargetClass } from "./DatalayerMethods"

const DatalayerAccordionClick = props => {
  const datalayerAccordionClickHandler = event => {
    let validClasses = [
      "luna-accordion__item-header",
      "luna-accordion__item-header-text",
    ]

    if (containsValidTargetClass(validClasses, event?.target?.classList)) {
      let text = null
      let accordionText = event.target.classList.contains(
        "luna-accordion__item-header-text"
      )
        ? event.target
        : event.target.querySelector(".luna-accordion__item-header-text")

      if (accordionText) {
        text = accordionText.textContent || accordionText.innerText || null
      }

      window.dataLayer.push({
        event: "accordion_click",
        accordion_label: text,
        accordion_action: null,
        content_heading: null,
        content_subheading: null,
        content_eyebrow: null,
      })
    }
  }
  // add handler if relevant listener elem exists
  let query = ""
  if (typeof window !== "undefined" && typeof document !== "undefined") {
    query =
      document?.querySelectorAll(
        ".luna-accordion__item-header, .luna-accordion__item-header-text"
      ).length > 0
  }
  useClickListener(datalayerAccordionClickHandler, query)
}

export default DatalayerAccordionClick
